<!--
 * @Author: awu
 * @Date: 2020-11-15 19:02:09
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-14 20:58:22
 * @Description: 大会议厅
-->
<template>
    <div class="small">
        <!-- <iframe src="https://pano.cloudvhall.com/#/preview?view_uuid=9865fec60f51454c"  style="width:100%;height:100%;border:0;" ></iframe> -->
        <iframe :src="iframesrc"  style="width:100%;height:100%;border:0;" ></iframe>
        <div class="warpper">
            <ul class="leftList list">
                <li
                    class="list-item"
                    v-for="(item, index) in leftList"
                    :key="index"
                    @click="choose(item)"
                    :class="{ active: item.chooseFlag == flagNum }"
                >
                    {{ bigconference.left[index] }}
                    <img class="img-left" v-if="item.chooseFlag == flagNum" :src="item.icon2" alt="" />
                    <img class="img-left" v-else :src="item.icon1" alt="" />
                </li>
            </ul>
            <ul class="rightList list">
                <li
                    class="list-item"
                    v-for="(item, index) in rightList"
                    :key="index"
                    @click="choose(item)"
                    :class="{ active: item.chooseFlag == flagNum }"
                >
                    <img class="img-right" v-if="item.chooseFlag == flagNum" :src="item.icon2" alt="" />
                    <img class="img-right" v-else :src="item.icon1" alt="" />
                    {{ bigconference.right[index] }}
                </li>
            </ul>
            <div class="video-live-wrapper" v-if="$route.path === '/area/bigconference' && videoSrc">
                <LiveVideo :videoSrc="videoSrc" />
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import LiveVideo from "@/components/LiveVideo";
import { FORUM_VIDEO_URL, EXHIBITION_ID } from "../../assets/common/data";

export default {
    components: {
        LiveVideo
    },
    data() {
        return {
            iframesrc: '',
            exhibition_id: '',
            mainVideoSrc: '',
            leftList: [
                {
                    path: `/area/bigconference/bigAgenda`,
                    chooseFlag: 1,
                    icon1: require("../../assets/area/rc.png"),
                    icon2: require("../../assets/area/rc.png")
                }
            ],
            rightList: [
                {
                    path: "/area/bigconference/bigGuest",
                    chooseFlag: 2,
                    icon1: require("../../assets/user/accountInfo.png"),
                    icon2: require("../../assets/user/accountInfo.png")
                }
            ],
            flagNum: 0,
            videoSrc: "",
            isShow: false,
        };
    },
    // watch: {
    //     $route: {
    //         handler(route) {
    //             console.log( route.query.exhibition_id)
    //             console.log( this.exhibition_id)
    //             let route_exhibition_id = route.query.exhibition_id
    //             if(route_exhibition_id){
    //                 switch (route.query.exhibition_id) {
    //                     case '21':
    //                         this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=e0ebcabc59568a8b";
    //                         break;
    //                     case '25':
    //                         this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=c9ee9b4475756fcb";
    //                         break;
    //                     default:
    //                         break;
    //                 }
    //             }
    //         },
	// 	    immediate: true,
    //     },
    // },
    mounted() {
        this.isShow = false;
        this.$root.$on("close", (idName, router) => {
            this.flagNum = 0;
        });
        // this.$refs.video.currentTime = 5;
        // this.$refs.video.addEventListener("ended", () => {
        //     this.isShow = true;
        // });
        this.exhibition_id = this.$route.query.exhibition_id
        console.log(this.exhibition_id)
        if(this.exhibition_id){
            switch (this.exhibition_id) {
                case '21':
                    this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=e0ebcabc59568a8b";
                    break;
                case '25':
                    this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=c9ee9b4475756fcb";
                    break;
                case '31':
                    this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=c5f74e143f71074e";
                    break;
                case '34':
                    this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=f25a6371de9347e3";
                    break;
                case '41':
                    this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=bb07a1e89c9653fe";
                    break;
                case '50':
                    this.iframesrc = "https://veh.cloudvhall.com/#/preview/U042aVZEaWlHcDgvT0NlSndYaDEvZz09";
                    break;
                case '60':
                    this.iframesrc = "https://veh.cloudvhall.com/#/preview/RXY4bW5qaXlaK3o4VzZUWjJiN0dCQT09";
                    break;
                default:
                    break;
            }
        }
    },
    methods: {
        choose(item) {
            const { path, chooseFlag } = item;
            this.flagNum = chooseFlag;
            this.$router.push(path+'?exhibition_id='+this.exhibition_id);
        }
    },
    computed: {
        bigconference() {
            return this.$t("bigconference");
        }
    },
    // watch: {
    //     $route(val) {
    //         if (val.path === "/area/bigconference") {
    //             this.videoSrc = this.$route.query.videoSrc ? decodeURIComponent(this.$route.query.videoSrc) : "";
    //         }
    //     }
    // }
};
</script>

<style lang="scss" scoped>
.small {
    width: 100%;
    height: 100vh;
    position: relative;
    z-index: 0;
    background-color: #fff;
    .video-live-wrapper {
        position: fixed;
        left: 40.5%;
        top: 39%;
        width: 20%;
        height: 20.5%;
    }
    #videoPlay {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 5;
    }

    .list {
        position: absolute;
        top: 200px;
        width: 220px;
        &-item {
            position: relative;
            height: 50px;
            background: #fff;
            box-shadow: 2px 4px 6px 0px rgba(0, 0, 0, 0.2), -2px -4px 6px 0px rgba(255, 255, 255, 0.4), 0px 0px 6px 4px rgba(255, 255, 255, 0.1);
            margin-bottom: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #09468c;
            cursor: pointer;
            line-height: 19px;
            .img-left {
              position: absolute;
              right: 0;
              width: 18px;
              margin-left: 7px;
              margin-right: 7px;
              opacity: 1;
            }
            .img-right {
              position: absolute;
              left: 0;
              width: 18px;
              margin-left: 7px;
              margin-right: 7px;
              opacity: 1;
            }
        }
        .active {
            color: #09468c;
        }
    }
    .rightList {
        right: 0;
        > li {
            border-radius: 12px 0 0 12px;
        }
    }
    .leftList {
        left: 0;
        > li {
            border-radius: 0 12px 12px 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/conference/big.vue